module.exports = __webpack_public_path__ + "s12.no2.538a5518.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/s12.no2.jpg
// module id = I1Tx
// module chunks = 0